import { atom } from 'jotai';

import { validateZipCode } from '@service-initiation/tech-care-utils-validators';

import {
  DeliveryMethod,
  type MailIn,
  type ParsedStore,
  type RemoteTech,
} from '../types';
import { deliveryMethodAsyncAtom } from './deliveryMethodAsyncAtom';
import { mailInAtom } from './mailInAtom';
import { remoteTechAtom } from './remoteTechAtom';
import { selectedStoreAsyncAtom } from './selectedStoreAsyncAtom';

export const validateSelectedStoreField = (
  selectedStore?: ParsedStore
): boolean => !!selectedStore;

export const validateShippingAddress = (mailIn?: MailIn): boolean => {
  return !(
    !mailIn?.shippingAddress?.streetAddress ||
    !mailIn?.shippingAddress?.city ||
    !mailIn?.shippingAddress?.state ||
    validateZipCode(mailIn?.shippingAddress?.zip) === false
  );
};

export const validateRemoteTech = (remoteTech?: RemoteTech): boolean => {
  const validAddress = !(
    !remoteTech?.meetingAddress?.streetAddress ||
    !remoteTech?.meetingAddress?.city ||
    !remoteTech?.meetingAddress?.state ||
    validateZipCode(remoteTech?.meetingAddress?.zip) === false
  );
  return validAddress;
};

export const completedDeliverySelection = (
  deliveryMethod?: DeliveryMethod,
  mailIn?: MailIn,
  remoteTech?: RemoteTech,
  selectedStore?: ParsedStore
) => {
  switch (deliveryMethod) {
    case DeliveryMethod.ComeToMe:
      return validateRemoteTech(remoteTech);
    case DeliveryMethod.MailIn:
      return validateShippingAddress(mailIn);
    default:
      return validateSelectedStoreField(selectedStore);
  }
};

export const deliverySelectionPageValidAsyncAtom = atom(async (get) => {
  const selectedStore = await get(selectedStoreAsyncAtom);
  const deliveryMethod = await get(deliveryMethodAsyncAtom);
  const mailIn = get(mailInAtom);
  const remoteTech = get(remoteTechAtom);

  return completedDeliverySelection(
    deliveryMethod,
    mailIn,
    remoteTech,
    selectedStore
  );
});
